import React from "react"

import ItemModelV2 from "../../../../../../../model2/item2/item-model"
import TasksView_Column from "../../../../../../../model2/column/column"
import FieldProto from "../../../../../../proto/field-proto"
import {ItemModelV2_CalculatedValues} from "../../../../../../../model2/item2/calculated/@type"
import {ToggleSize} from "../../../components/toggle-statefull"
import FieldToggle_Component from "../../../components/toggle-stateless"


type Props = {
    style?          : any

    listItem        : ItemModelV2
    column          : TasksView_Column
    field           : FieldProto

    isEditable      : boolean

    onMouseEnter    : callback
    onMouseLeave    : callback
}

// const debug = "FieldToggle_TableCellCalculated_NotHovered"
const debug = false

export default function FieldToggle_TableCellCalculated_NotHovered(props: Props) {

    const showSummaryView   = props.listItem.view.isCollapsed
    let notHoveredContent   = null
    let aggregateIcon

    const calculatedValues: ItemModelV2_CalculatedValues | undefined = props.listItem.calculated.dataByAggregateFunction[props.field.fieldId as keyof {}]?.[props.column.aggregateFunction!]

    debug && console.log(debug, "renderNotHovered", showSummaryView, calculatedValues)

    if (showSummaryView && !!calculatedValues?.total.value) {
        notHoveredContent = '{0}/{1}'.f(calculatedValues.total.sum, calculatedValues.total.itemsWithValue)
        aggregateIcon = <div className={Classes("ui5-ico-12 m-r-5 m-t-1", props.column.aggregator?.icon)}/>
    } else if (props.isEditable) {
        const value = props.field.getViewValue(props.listItem.item)
        notHoveredContent = (
            <FieldToggle_Component size    = {ToggleSize.SIZE_16}
                                   value   = {value}/>
        )
    }

    return (
        <div className      = "cell-flex ui5-field-editable size-small ui5-txt-less-important-small"
             style          = {props.style}
             onMouseEnter   = {props.onMouseEnter}
             onMouseLeave   = {props.onMouseLeave}>
            {aggregateIcon}

            {notHoveredContent}
        </div>
    )
}
